import { Component, Object3D, TextComponent } from '@wonderlandengine/api';
import { delay } from '../utils/delay.js';
import { TextFade } from './text-fade.js';
import { property } from '@wonderlandengine/api/decorators.js';
import { CursorTarget } from '@wonderlandengine/components';

/**
 * scene1-firstDoor
 * Used to FadeIn Tutorial Text after DoorOpen
 */
export class Scene1FirstDoor extends Component {
    static TypeName = 'scene1-firstDoor';

    @property.object({ required: true })
    textObj03!: Object3D;

    private cursorTarget?: CursorTarget;
    private textFade?: TextFade;
    private textComponent?: TextComponent;

    start() {
        this.cursorTarget =
            this.object.getComponent(CursorTarget) ||
            this.object.addComponent(CursorTarget)!;

        const tempTextFade = this.textObj03.getComponent(TextFade);
        if (!tempTextFade) {
            throw new Error(
                `scene1-firstDoor(${this.object.name}): textObj03 does not have a TextFade`
            );
        }
        this.textFade = tempTextFade;

        const tempText = this.textObj03.getComponent(TextComponent);
        if (!tempText) {
            throw new Error(
                `scene1-firstDoor(${this.object.name}):  does not have a TextComponent`
            );
        }
        this.textComponent = tempText;
    }

    onActivate(): void {
        this.cursorTarget!.onDown.add(this.onDown);
    }

    onDeactivate(): void {
        this.cursorTarget!.onDown.remove(this.onDown);
    }

    onDown = () => {
        if (this.engine.xr) {
            this.textComponent!.text = 'Move Forward\nwith Left\nStick';
        } else {
            if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                this.textComponent!.text = 'Look with\nRight Stick,\nMove with\nLeft Stick';
            } else {
                this.textComponent!.text = 'Move Around\nwith WASD\nand Mouse';
            }
        }

        delay(1).then(() => {
            this.textFade!.fadeIn();
        }).catch(console.error);
    }
}
